import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class SidebarLogin extends React.Component {
	render() {
		const { children, url, type, className } = this.props
		let markup = null

		if ( ! siteData.is_user_logged_in ) {
			markup = (
				<div className="sidebar-login">
					<h4>Login or register to access the resources</h4>

					<form className="form" name="loginform" id="loginform" action={ siteData.login_action_url } method="post">
						<p className="login-username">
							<label htmlFor="user_login">Email</label>
							<input type="text" name="log" id="user_login" className="input" size="20" />
						</p>

						<p className="login-password">
							<label htmlFor="user_pass">Password</label>
							<input type="password" name="pwd" id="user_pass" className="input" size="20" />
						</p>

						<p className="login-submit">
							<button name="wp-submit" id="wp-submit" className="button">Log in</button>
							<input type="hidden" name="redirect_to" value={ siteData.site_url } />
						</p>
					</form>
				</div>
			)
		}

		return markup
	}
}

export default SidebarLogin



// WEBPACK FOOTER //
// ./components/Login/SidebarLogin.jsx